/* ───────────────────── TIME BLOCK CONSTANTS ───────────────────── */
export const ALL_BLOCKS = ["08","10","12","14","16","18","20"];
export const AM_BLOCKS = ["08","10","12"];
export const PM_BLOCKS = ["14","16","18","20"];
export const BLOCK_LABELS = {
  "08": "8–10a", "10": "10–12p", "12": "12–2p",
  "14": "2–4p", "16": "4–6p", "18": "6–8p", "20": "8–10p",
};

export function isFullDay(blocks) {
  return blocks && blocks.length === ALL_BLOCKS.length;
}

export function isPartialDay(blocks) {
  return blocks && blocks.length > 0 && blocks.length < ALL_BLOCKS.length;
}
